import type { OutboxQueue } from '@/application/ports/OutboxQueue';
import { IdbOutboxQueue } from './IdbOutboxQueue';
import { MemoryOutboxQueue } from './MemoryOutboxQueue';

/**
 * Picks the durable queue where the browser offers one.
 *
 * The check is for the global rather than a try around a write, because the
 * failure we are guarding against is a browser that has no IndexedDB at all:
 * jsdom under test, and private browsing in one or two engines. A browser that
 * has it but errors on quota is a different problem and belongs in the tray,
 * not in a silent downgrade.
 */
export function createOutboxQueue(): OutboxQueue {
  if (typeof indexedDB === 'undefined') return new MemoryOutboxQueue();
  return new IdbOutboxQueue();
}
